import { defineComponent as _defineComponent } from 'vue'
import {computed} from "vue";
import {CurrencyCode} from "@/models/core/currency";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputAmountCurrency',
  props: {
  value: {
    type: [String, Number],
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  currency: {
    type: String,
    default: CurrencyCode.USD,
  },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;




const inputGroupClass = computed(() => {
  return { 'disabled-input-group': props.disabled };
})



const onInput = ($event: any) => {
  emit('input', $event.target.value);
}

const value = computed({
  get() {
    return props.value;
  },
  set(value: string) {
    emit('input', value);
  }
})

return { __sfc: true,props, inputGroupClass, emit, onInput, value, computed, CurrencyCode }
}

})